// Хуки для работы с ref_base_tariffs (ClickHouse)
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { message } from 'antd'
import * as api from '@/api/refBaseTariffs'

export const useBaseTariffs = () => {
  return useQuery({
    queryKey: ['base-tariffs'],
    queryFn: api.fetchBaseTariffs,
  })
}

export const useCreateBaseTariff = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: api.createBaseTariff,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['base-tariffs'] })
      message.success('Тариф создан')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при создании тарифа')
    },
  })
}

export const useUpdateBaseTariff = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ year, careType, data }: { year: number; careType: string; data: api.BaseTariffUpdate }) =>
      api.updateBaseTariff(year, careType, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['base-tariffs'] })
      message.success('Тариф обновлён')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при обновлении тарифа')
    },
  })
}

export const useDeleteBaseTariff = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ year, careType }: { year: number; careType: string }) =>
      api.deleteBaseTariff(year, careType),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['base-tariffs'] })
      message.success('Тариф удалён')
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при удалении тарифа')
    },
  })
}

export const useSeedBaseTariffs = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: api.seedBaseTariffs,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['base-tariffs'] })
      message.success(`Загружено ${data.total} тарифов`)
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.detail || 'Ошибка при загрузке тарифов')
    },
  })
}
